import {
  RoomStreamToPublishVORaw,
  roomStreamToPublishVORaw
} from "@youm-front/room/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomStreamToPublishVO {
  private static validation = JsonSchemaValidator.compile(
    RoomStreamToPublishVO.validationSchema()
  );

  constructor(readonly value: RoomStreamToPublishVORaw) {
    JsonSchemaValidator.assert(RoomStreamToPublishVO.validation, value);
  }

  private static validationSchema() {
    return roomStreamToPublishVORaw;
  }
}
